"use client"

import classNames from "classnames"
import styles from "../../styles/LandingPage/Patients.module.scss"
import SText from "../components/Text/SText"
import Image from "next/image"
import StyledText from "../typography/typography-component"
import skColors from "../../styles/skColors"
import { useTranslations } from "next-intl"
import router from "next/router"
import { Routes } from "src/data/routes"
import Button from "../components/Button/Button"

const AboutUs = ({}) => {
  const t = useTranslations("index")
  return (
    <div id={"about"} className={classNames(styles.aboutUsContainer)}>
      <Image
        className={styles.aboutUsImage}
        src={"/images/team_photo.webp"}
        alt={"Team"}
        width={560}
        height={375}
        quality={90}
        style={{
          maxWidth: "100%",
          height: "auto",
        }}
      />
      <div className={classNames(styles.aboutUsTitle)}>
        <StyledText className={styles.adaptiveTitleSize} variant={"h2"} color={skColors.turquoise[600]}>
          {t("history.title")}
        </StyledText>
      </div>
      <div className={classNames(styles.aboutUsText)}>
        <div className={styles.aboutUsParagraphs}>
          <StyledText variant={"pRegular"}>{t("history.paragraph1")}</StyledText>
          <StyledText variant={"pRegular"}>{t("history.paragraph2")}</StyledText>
          <StyledText variant={"pRegular"}>{t("history.paragraph3")}</StyledText>
        </div>
      </div>
      <div className={styles.aboutUsButtonRow}>
        <Button hug onClick={() => router.push(Routes.aboutUs)} variant="primary">
          {t("eligibility.cta2")}
        </Button>
      </div>
    </div>
  )
}

export default AboutUs
